export default __webpack_public_path__ + "static/drukarki_dzierzaw_MP6055-8381f69bb04c615040a684ad16d9576e.png";